import WHowSpit from './WHowSpit'

export default WHowSpit
